const FilterPanel = {
  getToggleTriggers: () => {
    return Array.from(document.querySelectorAll(".filter__toggle-trigger"));
  },

  getGroupTriggers: () => {
    return Array.from(document.querySelectorAll(".filter__group__btn-toggle"));
  },

  getShowMoreTriggers: () => {
    return Array.from(
      document.querySelectorAll(".filter__group__btn-show-more")
    );
  },

  getTagsPresent: () => {
    const tagsPresent = digiteketData.tag_terms_present;
    //console.log(`tagsPresent: ${tagsPresent}`);
    return tagsPresent;
  },

  resetTagsPresent: () => {
    const filterRows = Array.from(
      document.querySelectorAll("#filter-panel .filter__row")
    );

    if (filterRows) {
      filterRows.forEach((row) => {
        row.classList.remove("filter__row--is-present");
      });
    }
  },

  updateTagsPresent: () => {
    const tagsPresent = FilterPanel.getTagsPresent();
    const filterRows = Array.from(
      document.querySelectorAll("#filter-panel .filter__row")
    );

    // reset tags present before updating
    FilterPanel.resetTagsPresent();

    // set is-present class to rows based on tags present array
    if (tagsPresent) {
      tagsPresent.forEach((tag) => {
        if (filterRows) {
          filterRows.forEach((row) => {
            if (row.dataset.value == tag) {
              row.classList.add("filter__row--is-present");
            }
          });
        }
      });
    }
  },

  // show only the first 7 rows initially
  setInitialGroupRowStates: () => {
    const groupItemsWrapper = Array.from(
      document.querySelectorAll(".filter__group__items")
    );

    if (groupItemsWrapper) {
      // loop over every group item wrapper
      groupItemsWrapper.forEach((group) => {
        // get current group show more btn
        const groupShowMoreBtn = group.querySelector(
          ".filter__group__btn-show-more"
        );

        // get every row in group
        const groupItemRows = Array.from(
          group.querySelectorAll(".filter__row--is-present")
        );

        if (groupItemRows) {
          // loop over every row
          for (let i = 0; i < groupItemRows.length; i++) {
            if (i >= 7) {
              // hide row
              groupItemRows[i].classList.add("filter__row--is-hidden");

              // show btn based on whether row has is-present
              // if (
              //   !groupItemRows[i].classList.contains("filter__row--is-present")
              // ) {
              // }

              // show btn
              groupShowMoreBtn.classList.add(
                "filter__group__btn-show-more--is-visible"
              );
            }
          }
        }
      });
    }
  },

  // show hidden group row items (more tags)
  showMoreTags: (btn) => {
    // get closest group items wrapper
    const groupItemsWrapper = btn.closest(".filter__group__items");

    if (groupItemsWrapper) {
      // get every row in group
      const groupRows = Array.from(
        groupItemsWrapper.querySelectorAll(".filter__row")
      );

      if (groupRows) {
        // remove hidden state for every hidden row in group
        groupRows.forEach((row) => {
          row.classList.remove("filter__row--is-hidden");
        });

        // remove btn
        if (btn) {
          btn.remove();
        }
      }
    }
  },

  // get every checked checkbox
  getCheckedBoxes: () => {
    return Array.from(
      document.querySelectorAll('#filter-panel input[type="checkbox"]:checked')
    );
  },

  clearCheckedBoxes: () => {
    // get filter panel
    const panel = document.getElementById("filter-panel");

    if (panel) {
      // get form tag
      const currentForm = panel.closest("form");

      // get all checkboxes
      const checkboxes = Array.from(
        panel.querySelectorAll('input[type="checkbox"]')
      );

      if (checkboxes) {
        checkboxes.forEach((item) => {
          // clear every checkbox
          item.checked = false;
          FilterPanel.setClearBtnState();
        });

        if (currentForm) {
          // re-submit form
          currentForm.submit();
        }
      }
    }
  },

  setClearBtnState: () => {
    const btnClear = document.getElementById("filter__btn-clear");

    if (btnClear) {
      // check if any checkbox is checked
      const checkedBoxes = FilterPanel.getCheckedBoxes();

      // set enabled/disabled state
      if (checkedBoxes.length !== 0) {
        btnClear.removeAttribute("disabled");
      } else {
        btnClear.setAttribute("disabled", "");
      }
    }
  },

  initClearBtn: () => {
    const panel = document.getElementById("filter-panel");
    const btnClear = document.getElementById("filter__btn-clear");

    if (btnClear) {
      // set initial state on clear btn
      FilterPanel.setClearBtnState();

      btnClear.addEventListener("click", function (e) {
        e.preventDefault();
        FilterPanel.clearCheckedBoxes();
      });

      if (panel) {
        // get form tag
        const currentForm = panel.closest("form");

        // update clear btn when form changes
        currentForm.addEventListener("change", function () {
          FilterPanel.setClearBtnState();
        });
      }
    }
  },

  getFilterState: () => {
    // get state from localStorage
    let digi_filter_visible = JSON.parse(
      localStorage.getItem("digi_filter_visible") || null
    );

    // no state in localstorage, set it
    if (digi_filter_visible === null) {
      // get viewport width
      const initialViewPortWidth = window.innerWidth;

      // show filter for larger screens if it's not already set
      if (initialViewPortWidth > 576) {
        FilterPanel.setFilterState(true);
      } else {
        FilterPanel.setFilterState(false);
      }
    }

    // get values from localStorage
    digi_filter_visible = JSON.parse(
      localStorage.getItem("digi_filter_visible") || null
    );

    return digi_filter_visible;
  },

  setFilterState: (data) => {
    // set state to localstorage
    localStorage.setItem("digi_filter_visible", JSON.stringify(data));
  },

  init: () => {
    const htmlEl = document.querySelector("html");
    const filterPanel = document.getElementById("filter-panel");

    // get initial filter panel state
    let filterIsVisible = FilterPanel.getFilterState();

    // get every filter toggle trigger
    const filterToggleBtns = FilterPanel.getToggleTriggers();

    // get every group toggle trigger
    const filterGroupToggleBtns = FilterPanel.getGroupTriggers();

    // get every show more trigger
    const filterShowMoreBtns = FilterPanel.getShowMoreTriggers();

    if (filterPanel && filterToggleBtns) {
      // add visible classes on larger screens

      // checks value from localstorage, show filter if true
      if (filterIsVisible) {
        htmlEl.classList.add("page-filter--is-visible");
        filterPanel.classList.add("filter--is-visible");

        // set inital aria-expanded
        filterToggleBtns.forEach((btn) => {
          btn.setAttribute("aria-expanded", "true");
        });
      }

      // setup filter toggle triggers
      filterToggleBtns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          FilterPanel.togglePanel(this);
        });
      });

      // initialize filter group toggle btns
      if (filterGroupToggleBtns) {
        filterGroupToggleBtns.map((filterGroupBtn) => {
          filterGroupBtn.addEventListener("click", function (e) {
            e.preventDefault();
            const currentGroup = this.closest(".filter__group");
            const currentGroupItems = currentGroup.querySelector(
              ".filter__group__items"
            );

            // toggle aria-expanded attr
            let ariaExpanded =
              this.getAttribute("aria-expanded") === "true" || false;
            this.setAttribute("aria-expanded", !ariaExpanded);

            // toggle visibility of items
            if (this.getAttribute("aria-expanded") === "true") {
              currentGroupItems.classList.add(
                "filter__group__items--is-expanded"
              );
            } else {
              currentGroupItems.classList.remove(
                "filter__group__items--is-expanded"
              );
            }
          });
        });

        // initialize show more btns in every group
        if (filterShowMoreBtns) {
          filterShowMoreBtns.forEach((btn) => {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
              FilterPanel.showMoreTags(this);
            });
          });
        }

        // show only a few checkboxes in each group
        FilterPanel.setInitialGroupRowStates();
      }

      FilterPanel.initClearBtn();
    }
  },

  togglePanel: function () {
    const htmlEl = document.querySelector("html");
    const filterPanel = document.getElementById("filter-panel");

    // toggle visible class on filter panel
    filterPanel.classList.toggle("filter--is-visible");

    // get every filter toggle trigger
    const filterToggleBtns = FilterPanel.getToggleTriggers();

    // sync attr across every toggle trigger
    filterToggleBtns.forEach((item) => {
      let ariaExpanded = item.getAttribute("aria-expanded") === "true" || false;
      item.setAttribute("aria-expanded", !ariaExpanded);
    });

    // set class to html element
    if (filterPanel.classList.contains("filter--is-visible")) {
      htmlEl.classList.add("page-filter--is-visible");
      FilterPanel.setFilterState(true);
    } else {
      htmlEl.classList.remove("page-filter--is-visible");
      FilterPanel.setFilterState(false);
    }
  },
};

export default FilterPanel;
